import React, {useState} from 'react'
import Switch from "react-bootstrap-switch";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import { useForm } from "react-hook-form";
import {connect, useSelector} from "react-redux";

import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import {PH_CODE} from "../../../components/i18n/placeHolders";
import {FL_ALLOWED_TO_BUY, FL_CODE} from "../../../components/i18n/formLabels";
import {getStateByPath} from "../../../redux/selectors";
import {LB_ACTIVE} from "../../../components/i18n/i18n";
import {setFilter} from "../../../redux/actions/generics/IndexedActions";

const RoutFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { filter, app, udn } = componentState?.data || {};

    const [status, setStatus] = useState(filter?.status || null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            code: filter?.code || ''
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : { id: app?.fbDataBase?.id},
            item : {
                ...data,
                udn: { id : udn?.id }
            }
        };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setStatus(null)
        reset({
            code: ''
        });
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{LB_ACTIVE}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={12} className={'d-flex justify-content-center'}>
                        <div className="float-right ">
                            <ButtonSearch/>
                            <ButtonClean onClick={cleanFields}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({setFilter})

export default connect(mapStateToProps, mapActionsToProps)(RoutFilters)